import { SmallSelectField } from '@/components/Form';
import { useTransitionConditionAtom } from '@/features/analyze/atoms/transitionCondition';
import { DURATION_GAPS } from 'src/features/analyze/constants';

export const TransitionRangeGapSelect = () => {
  const [transitionCondition, setTransitionCondition] =
    useTransitionConditionAtom();

  const defaultValue = DURATION_GAPS.find(
    (option) => option.value === transitionCondition.rangeGap
  );

  return (
    <SmallSelectField
      className="text-black"
      options={DURATION_GAPS}
      value={defaultValue}
      isSearchable={false}
      onChange={(newValue) => {
        if (!newValue) return;
        setTransitionCondition((prev) => ({
          ...prev,
          rangeGap: newValue.value,
        }));
      }}
    />
  );
};
